import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "../api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [emailSent, setEmailSent] = useState(true);
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErr("");
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            setEmailSent(!!data?.email_sent);
            setSent(true);
        } catch (e) {
            setErr(errMsg(e));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto px-5 py-20" data-testid="forgot-password-page">
            <div className="card p-8">
                <h1 className="font-serif text-3xl text-[var(--ink)] mb-1">Reset password</h1>
                <p className="text-[var(--body)] text-sm mb-6">Enter your email and we'll send you a reset link.</p>
                {sent ? (
                    <div className="text-[14px] text-[var(--ink-soft)] space-y-3" data-testid="forgot-success">
                        <p>If an account exists for <b>{email}</b>, a reset link has been sent.</p>
                        {!emailSent && (
                            <p className="text-[12px] text-[var(--terra)]">
                                Email delivery isn't configured yet. Check the backend logs for the reset link, or have your admin configure SMTP in <span className="font-medium">Admin → Email (SMTP)</span>.
                            </p>
                        )}
                        <Link to="/login" className="btn btn-outline btn-sm mt-3 inline-flex">Back to sign in</Link>
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label className="lbl">Email</label>
                            <input className="field" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
                        </div>
                        {err && <div className="text-sm text-[var(--terra)]">{err}</div>}
                        <button className="btn btn-primary w-full" disabled={loading} data-testid="forgot-submit">
                            {loading ? "Sending…" : "Send reset link"}
                        </button>
                        <div className="text-center text-sm text-[var(--body)]">
                            Remember your password? <Link to="/login" className="text-[var(--ink)] underline">Sign in</Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
